import { render, staticRenderFns } from "./addNewTask.vue?vue&type=template&id=2d8ce7a8&scoped=true&"
import script from "./addNewTask.vue?vue&type=script&lang=js&"
export * from "./addNewTask.vue?vue&type=script&lang=js&"
import style0 from "./addNewTask.vue?vue&type=style&index=0&id=2d8ce7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ce7a8",
  null
  
)

export default component.exports